/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Apr_S3Inputs */

const en_mk_tut_apr_s3 = /** @type {(inputs: Mk_Tut_Apr_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose **Approve**, **Ask for revision** or **Reject**. Asking for a revision restarts the agent with your note; ⌘⏎ approves without leaving the keyboard.`)
};

const id_mk_tut_apr_s3 = /** @type {(inputs: Mk_Tut_Apr_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih **Setujui**, **Minta revisi**, atau **Tolak**. Meminta revisi memulai ulang kerja agen dengan catatan Anda; ⌘⏎ menyetujui tanpa lepas dari papan tik.`)
};

/**
* | output |
* | --- |
* | "Choose **Approve**, **Ask for revision** or **Reject**. Asking for a revision restarts the agent with your note; ⌘⏎ approves without leaving the keyboard." |
*
* @param {Mk_Tut_Apr_S3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_apr_s3 = /** @type {((inputs?: Mk_Tut_Apr_S3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Apr_S3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_apr_s3(inputs)
	return en_mk_tut_apr_s3(inputs)
});